"use client";

import React from "react";
import Link from "next/link";

const WhatAreClearAligners: React.FC = () => {
  return (
    <section className="w-full py-6 sm:py-8 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-8 md:px-12 space-y-6 text-center md:text-left">
        <h2
          className="
            text-2xl sm:text-3xl font-semibold text-gray-800 text-center
            pb-6 after:content-[''] after:block after:w-[200px] after:h-[3px] after:mx-auto after:mt-2
            after:bg-[linear-gradient(to_right,#AE7D2F_0%,#ECD05B_50%,#AE7D2F_100%)]
          "
        >
          What Are Clear Aligners?
        </h2>
        <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
          Custom-made, removable trays gradually shift your teeth into proper
          alignment. Unlike traditional braces, clear aligners offer several
          key advantages:
        </p>
        <ul className="list-disc list-inside space-y-3 text-gray-700 text-base sm:text-lg leading-relaxed">
          <li>
            <strong>Virtually Invisible:</strong> No metal wires or brackets
          </li>
          <li>
            <strong>Comfortable:</strong> Made from smooth, BPA-free plastic
          </li>
          <li>
            <strong>Removable:</strong> Easy to take out when eating, drinking,
            or brushing
          </li>
        </ul>

        <h3 className="text-xl sm:text-2xl font-semibold text-gray-800 pt-2">
          How Does Treatment Work?
        </h3>
        <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
          The{" "}
          <Link
            href="/blog/invisalign-process-step-by-step/"
            className="inline-block bg-gradient-to-r from-[#AE7D2F] via-[#ECD05B] to-[#AE7D2F] bg-clip-text text-transparent hover:underline transition-all duration-300 ease-in-out"
          >
            Invisalign process
          </Link>{" "}
          is straightforward from start to finish:
        </p>
        <ol className="list-decimal list-inside space-y-3 text-gray-700 text-base sm:text-lg leading-relaxed">
          <li>
            <strong>Consultation and 3D Imaging:</strong> We scan your teeth
            and map your new smile, then develop a customized treatment plan.
          </li>
          <li>
            <strong>Aligner Fitting:</strong> You receive a series of aligners
            worn for 20&ndash;22 hours daily.
          </li>
          <li>
            <strong>Progressive Shifts:</strong> Switch to a new aligner every
            1&ndash;2 weeks to gradually move teeth into place.
          </li>
          <li>
            <strong>Regular Check-Ups:</strong> We monitor progress every
            6&ndash;8 weeks and make any necessary adjustments.
          </li>
          <li>
            <strong>Final Results:</strong> After treatment, you&apos;ll wear a
            retainer to keep your new smile in place.
          </li>
        </ol>
      </div>
    </section>
  );
};

export default WhatAreClearAligners;
